import { render } from "./ContentField.vue?vue&type=template&id=6118b26e&scoped=true"
const script = {}

import "./ContentField.vue?vue&type=style&index=0&id=6118b26e&scoped=true&lang=css"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6118b26e"]])

export default __exports__